import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import useAuthorizationMailAddress from '../../hooks/Auth/useAuthorizationMailAddress';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';
import {
  OthersContainer,
  OthersTitleArea,
  OthersTitle,
  OthersCategoryButtonSection,
  OthersCategoryButton,
} from './OtherOptions.style';

import {
  GET_CREDIT_CHANGE_CHECK_REQUEST,
  GET_MEMBER_MENU_INITIAL,
  GET_MEMBER_MENU_REQUEST,
  GET_MEMBER_TRANSFER_STATUS_INITIAL,
  GET_RECESS_STATUS_INITIAL,
  GET_SHOP_BUTTON_INITIAL,
  UNPAID_OPERATION_CHECK_INITIAL,
} from '../../store/actions';

interface RouteItem {
  label: string;
  path: string;
}

const OtherOptions: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  useAuthorizationMailAddress();

  const routeItems: RouteItem[] = [
    { label: '領収書', path: '/receipt' },
    { label: '紹介コード発行', path: '/referralCode' },
    { label: 'クレジット切替', path: '/creditcardSwitching' },
    { label: '未納金支払', path: '/unpaid' },
    { label: '休会', path: '/recess' },
  ];

  const handleCategoryClick = (label: string) => {
    const selectedRoute = routeItems.find((item) => item.label === label);
    const toPage = selectedRoute?.path || '';
    if (toPage === '/creditcardSwitching') {
      // クレカ切替操作日チェックAPIを呼出し
      dispatch({
        type: GET_CREDIT_CHANGE_CHECK_REQUEST,
        member_id: sessionStorage.getItem('memberID'),
        history,
      });
    } else if (toPage === '/unpaid') {
      dispatch({
        type: UNPAID_OPERATION_CHECK_INITIAL,
      });
    } else if (toPage === '/recess') {
      // 休会をクリックすると、会員メニュー・店舗ボタン・休会状態・移籍状態APIを初期化
      dispatch({
        type: GET_MEMBER_MENU_INITIAL,
      });
      dispatch({
        type: GET_SHOP_BUTTON_INITIAL,
      });
      dispatch({
        type: GET_RECESS_STATUS_INITIAL,
      });
      dispatch({
        type: GET_MEMBER_TRANSFER_STATUS_INITIAL,
      });
      // 会員メニューを取得する
      dispatch({
        type: GET_MEMBER_MENU_REQUEST,
        memberId: sessionStorage.getItem('memberID') ?? '',
        shopId: sessionStorage.getItem('shopId') ?? '',
        history,
      });
    }
    history.push(toPage || '');
  };

  return (
    <>
      <MyPageLayout>
        <OthersContainer>
          <OthersTitleArea>
            <OthersTitle>各種手続き</OthersTitle>
          </OthersTitleArea>
          <OthersCategoryButtonSection>
            {routeItems.map((item) => (
              <OthersCategoryButton key={item.label} onClick={() => handleCategoryClick(item.label)} type="button">
                {item.label}
              </OthersCategoryButton>
            ))}
          </OthersCategoryButtonSection>
        </OthersContainer>
      </MyPageLayout>
    </>
  );
};

export default OtherOptions;
